import {
  AUDIO_SENTIMENT_VALUES,
  END_REASON_VALUES,
} from "@/constants/categorical-metric-values"

import type { MetricRecordData } from "@/types/metrics/contracts"

import { METRIC_MANAGERS } from "./metricManagerIds"

export const SENTIMENT_ANALYSIS_VALUES = [
  "Rude",
  "Polite",
  "Encouraging",
  "Professional",
] as const
export const MATCH_EXPECTED_RESULTS = {
  MATCH: "MATCH",
  DIFF: "DIFF",
  NOT_FOUND: "NOT_FOUND",
} as const
const registeredManagers = new Set<string>(Object.values(METRIC_MANAGERS))
const categoricalManagers = new Set<string>([
  METRIC_MANAGERS.manager_audio_llm_categorical,
  METRIC_MANAGERS.manager_default_categorical,
  METRIC_MANAGERS.manager_derived_strict_logic,
])

export function getAdditionalInformationCategories(
  metadata: MetricRecordData["metric_metadata"],
): string[] {
  return (
    metadata?.additional_information?.value
      ?.split(",")
      .map((value) => value.trim())
      .filter((value) => value.length > 0) ?? []
  )
}

export function getAgentJudgeCategories(
  metadata: MetricRecordData["metric_metadata"],
): string[] {
  return (metadata?.categories ?? []).filter(
    (category) => category.trim().length > 0,
  )
}

/** Resolve editor choices without constructing rendering records or their hooks. */
export function getMetricStringOptions(
  metric: MetricRecordData | null,
): string[] | null {
  if (!metric) {
    return null
  }
  let options: string[] = []
  switch (metric.metric_manager) {
    case METRIC_MANAGERS.manager_end_reason:
      options = [...END_REASON_VALUES]
      break
    case METRIC_MANAGERS.manager_custom_audio_sentiment:
    case METRIC_MANAGERS.manager_audio_sentiment:
      options = [...AUDIO_SENTIMENT_VALUES]
      break
    case METRIC_MANAGERS.manager_sentimentanalysis:
      options = [...SENTIMENT_ANALYSIS_VALUES]
      break
    case METRIC_MANAGERS.manager_match_expected_sim_wrapper:
      options = Object.values(MATCH_EXPECTED_RESULTS)
      break
    case METRIC_MANAGERS.manager_agentic_llm_judge_categorical:
      options = getAgentJudgeCategories(metric.metric_metadata)
      break
    default:
      if (
        categoricalManagers.has(metric.metric_manager) ||
        (!registeredManagers.has(metric.metric_manager) &&
          metric.output_type === "string")
      ) {
        options = getAdditionalInformationCategories(metric.metric_metadata)
      }
  }
  if (options.length) {
    return options
  }
  const categories = metric.metric_metadata?.categories
  if (Array.isArray(categories) && categories.length > 0) {
    return categories
  }
  if (metric.metric_metadata?.units === "binary") {
    return ["YES", "NO", "UNKNOWN"]
  }
  return null
}
